import React from "react"
import { Select, MenuItem, Grid, TextField, InputLabel } from "@material-ui/core"
import BlockBodySectionEditor from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionEditor"
import useContentEditor from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/hooks/useContentEditor"
import { ApiBlock, ChatBotFlowBlockContent } from "@/protocols/chatBot"
import useStyles from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/resources/Blocks/APIBlock/APIBlockBaseRequestDataSectionEditor/styles"
import { JsonEditor } from "@/components"
import useCustomStyles from "@/styles/custom"

type APIBlockBaseRequestDataSectionEditorProps = {
	onSave: (chatBotFlowBlockContent: ChatBotFlowBlockContent) => void
	chatBotFlowBlockContent: ChatBotFlowBlockContent
}

const APIBlockBaseRequestDataSectionEditor: React.FC<APIBlockBaseRequestDataSectionEditorProps> = ({
	chatBotFlowBlockContent,
	onSave,
	children
}) => {
	const contentEditor = useContentEditor({ chatBotFlowBlockContent })
	const apiBlock = contentEditor.content?.apiBlock
	const classes = useStyles()
	const customClasses = useCustomStyles()

	const handleCustomEventData = (key: keyof ApiBlock, value: string) => {
		contentEditor.changeContent({
			apiBlock: {
				...apiBlock,
				[key]: value
			}
		})
	}

	const handleJsonChange = (newJson: string) => {
		contentEditor.changeContent({
			...contentEditor.content,
			apiBlock: {
				...contentEditor.content.apiBlock,
				body: newJson
			}
		})
	}

	const handleOpen = () => {
		contentEditor.reset()
	}

	const handleSave = () => {
		onSave(contentEditor.content)
	}

	return (
		<BlockBodySectionEditor
			title="Configurações de requisição"
			onSave={handleSave}
			onOpen={handleOpen}
			AsideDrawerProps={{
				children: (
					<Grid item xs={12}>
						<Grid container direction="column" spacing={2}>
							<Grid item>
								<div className={classes.root}>
									<Select
										variant="outlined"
										value={apiBlock?.method || ""}
										onChange={e => handleCustomEventData("method", e.target.value as ApiBlock["method"])}
										className={classes.methodSelect}
									>
										<MenuItem value="GET">GET</MenuItem>
										<MenuItem value="POST">POST</MenuItem>
										<MenuItem value="PUT">PUT</MenuItem>
										<MenuItem value="DELETE">DELETE</MenuItem>
									</Select>

									<TextField
										variant="outlined"
										placeholder="https://sua-api.com/endpoint"
										value={apiBlock?.url || ""}
										onChange={e => handleCustomEventData("url", e.target.value)}
										style={{ height: 50, width: "100%" }}
										InputProps={{
											classes: {
												root: classes.urlRootInput
											}
										}}
									/>

								</div>
							</Grid>
							{apiBlock?.method !== "GET" && <Grid item>
								<Grid container direction="column" spacing={2}>
									<Grid item>
										<InputLabel className={customClasses.inputLabel}>
											Corpo da requisição
										</InputLabel>
									</Grid>
									<Grid>
										<Grid item>
											<JsonEditor
												width="421px"
												mode="json"
												defaultValue={contentEditor.content?.apiBlock?.body}
												onChange={handleJsonChange}
											/>
										</Grid>
									</Grid>
								</Grid>
							</Grid>}
						</Grid>
					</Grid>
				)
			}}
		>
			{children}
		</BlockBodySectionEditor>
	)
}

export default APIBlockBaseRequestDataSectionEditor
